<div class="widget-container" [ngClass]="{ mobile: responsiveService.isHandset$ | async }" cdkDropListGroup>
  <div *ngFor="let col of columnArray" cdkDropList (cdkDropListDropped)="drop($event)" class="column" [cdkDropListDisabled]="isMobile">
    <ng-template appWidget></ng-template>
  </div>
</div>
